import { render, staticRenderFns } from "./TextareaForm.vue?vue&type=template&id=cf70a06c&scoped=true&"
import script from "./TextareaForm.vue?vue&type=script&lang=js&"
export * from "./TextareaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf70a06c",
  null
  
)

export default component.exports